.variableControlHeader {
  padding: 0.5em;
  border-bottom: 1px dashed var(--darkSilver);
  border-top: 1px dashed var(--darkSilver);
  margin-bottom: 0.5em;
  display: flex;
  flex-direction: column;
  background-color: var(--lightSilver);
}

.variableSelectContainer {
  display: flex;
  justify-content: space-between;
}

.variableSelect {
  min-width: 14em;
  padding-right: 2.5em;
  width: auto;
}

.previewContainer {
  padding: 0.5em;
}

.infoText {
  font-size: 1.125rem;
  color: var(--gray);
  font-weight: 300;
  line-height: 2.4;
  padding: 0;
  margin: 0;

  p {
    margin-bottom: 0;
  }
}

.variableQuestionsContainer {
  display: flex;
  color: var(--gray);
  font-weight: 600;
}

.questionListLabel {
  font-weight: 300;
  font-size: 1.125em;
  padding-right: 1em;

  p {
    margin-bottom: 0;
  }
}

.questionList {
  margin-top: 0.2em;
  margin-bottom: 0.2em;
}

.questionCode {
  font-size: 0.9em;
}
